export default "__VITE_ASSET__Br$6YuHK__"